import request from '../../axios/axiosconfig.js'

export function getStoreList(params) {
  return request({
    url: '/ps/storeDeviceRelation/getStoreList',
    method: 'get',
    params: params
  })
}

export function getStoreDetail(params) {
  return request({
    url: '/ps/storeDeviceRelation/getStoreDetail/'+params,
    method: 'get'
  })
}

export function deviceUnbinding(data) {
  return request({
    url: '/ps/storeDeviceRelation/deviceUnbinding',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/relation/storeDeviceRelation.js